import { Handle, Position } from "reactflow";
import { BarsOutlined } from "@ant-design/icons";

import { useFlowNodes } from "../../../context";
import Phrases from "components/Accordion/AccordionIntents/inputs/phrases";

import { ButtonDelete } from "../../ButtonDelete";
import { handleDeletePhraseNode } from "../../utils/removeDataNode";

import "components/Accordion/styles/styles.scss";
import "./PhraseIntentNode.scss";

export const PhraseIntentNode = ({ id }) => {
  const { t, setNodes, setEdges, contexts, ...res } = useFlowNodes();
  return (
    <div className="phrases-node">
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div className="phrases-header">
        <div className="phrases-title">
          <div className="phrases-icon">
            <BarsOutlined />
          </div>
          <span className="phrases-name">
            {t("common:intents.flow_chat.entry.phrases")}
          </span>
        </div>
        <span className="phrases-add-button">
          <ButtonDelete
            setNodes={setNodes}
            setEdges={setEdges}
            nodeId={id}
            handleDelete={() => handleDeletePhraseNode(res.updateIntent)}
          />
        </span>
      </div>
      <div className={"accordion__content"}>
        <Phrases {...res} isFlow={true} type="phrases" />
      </div>
    </div>
  );
};
